import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "3.7487",
      y: "4.4611",
      width: "1.875",
      height: "12.5289",
      stroke: "#303333",
      "stroke-width": "0.833333"
    }, null, -1),
    _createElementVNode("rect", {
      x: "7.28971",
      y: "4.4611",
      width: "1.875",
      height: "12.5289",
      stroke: "#303333",
      "stroke-width": "0.833333"
    }, null, -1),
    _createElementVNode("rect", {
      x: "10.8327",
      y: "4.4611",
      width: "1.875",
      height: "12.5289",
      stroke: "#303333",
      "stroke-width": "0.833333"
    }, null, -1),
    _createElementVNode("rect", {
      x: "14.3737",
      y: "4.4611",
      width: "1.875",
      height: "12.5289",
      stroke: "#303333",
      "stroke-width": "0.833333"
    }, null, -1)
  ])))
}
export default { render: render }